import { render } from "./OrderDataConfirmation.vue?vue&type=template&id=65e9086c"
import script from "./OrderDataConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderDataConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__